import DOMPurify from "dompurify";
import { useSubscriptionCompetitionsPrizesPageContext } from "@/app/(custom-header)/prizes/[prizeName]/context";
import { useEffect } from "react";

const SubscribtionCompetitionModalContent = () => {
  const { competitionDetails } = useSubscriptionCompetitionsPrizesPageContext();

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div className="flex flex-col">
      <div
        className="max-h-[465px] h-[420px] overflow-auto"
        style={{ scrollbarGutter: "stable" }}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(competitionDetails.infoPopupContent),
        }}
      />
    </div>
  );
};

export default SubscribtionCompetitionModalContent;
